import { Project } from "../Project/Project.type";
import { User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type ProjectDrawing = {
  id: number;
  title: string;
  drawing_type: string;
  date: string;
  remark: string;
  url: string;
  size: number;
  project_id: number;
  revision_id?: number | null;
  revision?: any;
  user_id: number;
  user: User;
  project: Project;
  createdAt: string;
};

export type ProjectDrawingStateTypes = {
  fetchAll: ApiCallState<ProjectDrawing[]>;
};

export const ProjectDrawingActionTypes = {
  FETCH_ALL_PROJECT_DRAWING: "FETCH_ALL_PROJECT_DRAWING",
  FETCH_ALL_PROJECT_DRAWING_RESET: "FETCH_ALL_PROJECT_DRAWING_RESET",
  FETCH_ALL_PROJECT_DRAWING_FAILURE: "FETCH_ALL_PROJECT_DRAWING_FAILURE",
  FETCH_ALL_PROJECT_DRAWING_SUCCESS: "FETCH_ALL_PROJECT_DRAWING_SUCCESS",
};
